




































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import firebase from 'firebase/app';
import 'firebase/auth';
import * as M from "materialize-css";

const user = namespace("User");
@Component
export default class Navbar extends Vue {
  routes = [
    "Offers",
    "Cv",
    "Interviews",
    "Tests",
    "Training",
    "Networking"
  ]
  @user.State
  public name!: string;
  @user.State
  public email!: string;
  @user.State
  public claims!: {};

  oid = '';

  @user.Getter
  public initials!: string;

  @user.Action
  public updateName!: (newName: string) => void;

  mounted() {
    const dropDownElements = document.querySelectorAll("#top-bar .dropdown-trigger");
    M.Dropdown.init(dropDownElements, {
      constrainWidth: false
    });
    const sidenavElements = document.querySelectorAll('.sidenav');
    M.Sidenav.init(sidenavElements);
    if ('oid' in this.$route.params) {
      this.oid = this.$route.params.oid;
    }
  }

  public logOut(): void {
    firebase.auth().signOut().then(() => {
      this.$router.push("/login");
    });
  }
}
